import { action, makeAutoObservable, runInAction } from "mobx";

export class ServicePortalStore {
    initialPreviewData = {
        full_name: "",
        relation: "",
        relative_name: "",
        phone: "",
        whatsapp: "",
        gender: "",
        village: [],
        booth: [],
        request_type: [],
        audio: [],
        additionalInfo: "",
        attachment: [],
        dob: "",
        age: "",
        address: "",
        area: "",
    };

    previewData = { ...this.initialPreviewData };
    rootStore: any;
    qrDetails = null;
    qrLoading = false;

    constructor(rootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    @action
    setPreviewData(prevdata) {
        this.previewData = {
            ...this.previewData,
            ...prevdata,
        };
    }

    @action
    clearPreviewData() {
        this.previewData = { ...this.initialPreviewData };
    }

    async getQRDetails(payload) {
        this.qrLoading = true;

        try {
            console.log("STORE METHOD CALLED", payload);

            const res = await this.rootStore.api.post("unified_service_request/qr_code_details", payload);

            console.log("FULL API RESPONSE:", res);
            console.log("ACTUAL DATA:", res?.data);

            runInAction(() => {
                this.qrDetails = res?.data?.data || res?.data || null;
            });

            return res;
        } catch (error) {
            console.error("QR Details Error:", error);

            runInAction(() => {
                this.qrDetails = null;
            });
        } finally {
            runInAction(() => {
                this.qrLoading = false;
            });
        }
    }
}

export default ServicePortalStore;
